/* eslint-disable prettier/prettier */
/* eslint-disable react/prop-types */
import { Box, Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import AutoCompleteDropdown from "../../../components/common/new/AutoCompleteDropdown/AutoCompleteDropdown";
import InputField from "../../../components/common/new/InputField/InputField";
import useQueryParams from "../../../hooks/useQueryParams";
import {
  SET_CITIES,
  SET_DIVISIONS,
  SET_STATES,
  SET_SUB_DIVISIONS,
} from "../../../redux/actionTypes/meta";
import IntroductionFormApi from "../../../services/api/introductionForm";
import { getOptions } from "../../../utils";
import { isEmptyObj } from "../../../utils/helper";

const ExamLevels = [
  // { name: "Entrance", value: "ENTRANCE" },
  // { name: "Introductory", value: "INTRODUCTORY" },
  { name: "Intermediate", value: "INTERMEDIATE" },
  // { name: "Advanced", value: "ADVANCED" },
];

function ResultPersonalDetailSearch({ examLevel, setExamLevel }) {
  const [stateVal, setStateVal] = useState("");
  const [divisionVal, setDivisionVal] = useState("");
  const [divisions, setDivisions] = useState([]);
  const [states, setStates] = useState([]);
  const dispatch = useDispatch();
  const { getQueryObject, getQueryParams, urlSearchParams } = useQueryParams();

  const setMetaDataInRedux = (type, payload) => {
    dispatch({
      type,
      payload,
    });
  };

  const getDivisions = async () => {
    const response = await IntroductionFormApi.getDivisions();
    setDivisions(response.data);
    setMetaDataInRedux(SET_DIVISIONS, response.data);
  };

  const getStates = async () => {
    const response = await IntroductionFormApi.getStates();
    setStates(response.data);
    setMetaDataInRedux(SET_STATES, response.data);
  };

  useEffect(() => {
    getDivisions();
    getStates();
  }, []);

  useEffect(() => {
    const queryObject = getQueryObject();
    if (!isEmptyObj(queryObject)) {
      const query = getQueryParams(queryObject)[0];
      setStateVal(query?.state || "");
      setDivisionVal(query?.divisionId || "");
      setExamLevel(query?.examLevel || "INTERMEDIATE");
    } else {
      setStateVal("");
      setDivisionVal("");
      setExamLevel("INTERMEDIATE");
    }
  }, [urlSearchParams.toString()]);

  useEffect(() => {
    if (states.length && stateVal) {
      const newCities =
        states.find((state) => state.stateId === Number(stateVal))?.cities ??
        [];
      setMetaDataInRedux(SET_CITIES, newCities);
    }
  }, [states, stateVal]);

  useEffect(() => {
    if (divisions.length && divisionVal) {
      const newSubDivisions =
        divisions.find(
          (division) => division.divisionId === Number(divisionVal)
        )?.subDivisions ?? [];
      setMetaDataInRedux(SET_SUB_DIVISIONS, newSubDivisions);
    }
  }, [divisions, divisionVal]);
  // const [examDate, setExamDate] = useState("");
  const [examMonth, setExamMonth] = useState("");

  const ExamLevelDateMap = {
    ENTRANCE: [{ name: "Sep 2025", value: "2025-09-21" }],
    INTRODUCTORY: [{ name: "Sep 2024", value: "2024-09-29" }],
    INTERMEDIATE: [{ name: "Dec 2025", value: "2025-12-14" }],
    ADVANCED: [],
  };
  useEffect(() => {
    const options = ExamLevelDateMap[examLevel] || [];
    if (options.length === 1) {
      setExamMonth(options[0].value); // ✅ Auto-fix: Dec 2025 set ho jayega
    } else {
      setExamMonth(""); // reset for levels with multiple/no options
    }
  }, [examLevel]);

  const formatMonthYearToDate = (monthYear) => {
    if (!monthYear) return "";

    const [year, month, day] = monthYear.split("-");
    return `${day}/${month}/${year}`; // DD/MM/YYYY
  };

  return (
    <Box
      sx={{
        width: "100%",
        pr: { xs: "20px", sm: 0 },
        // ✅ Global styling for all fields
        "& .MuiInputBase-root": {
          height: "40px !important",
          fontSize: "14px",
          borderRadius: "8px",
          display: "flex",
          alignItems: "center",
        },
        "& .MuiInputLabel-root": {
          fontSize: "14px !important",
          fontWeight: 600,
        },
        "& .MuiInputLabel-shrink": {
          lineHeight: "1.4375em",
        },
        "& .MuiOutlinedInput-input": {
          padding: "8.5px 14px !important",
          height: "auto !important",
          fontSize: "14px",
        },
        "& .MuiOutlinedInput-notchedOutline": {
          borderRadius: "8px",
        },
        "& .MuiTextField-root": {
          "& .MuiInputBase-root": {
            height: "40px",
            alignItems: "center",
          },
        },
        "& .MuiInputBase-input": {
          height: "auto !important",
          padding: "8.5px 14px !important",
        },
      }}
    >
      <Grid
        container
        spacing={2}
        sx={{
          display: "grid",
          gridTemplateColumns: {
            xs: "1fr",
            sm: "1fr 1fr",
            md: "repeat(4, 1fr)",
          },
          rowGap: 2,
          columnGap: 2,
        }}
      >
        {/* Group 1: Member Details */}
        <Grid
          item
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 3,
            padding: 1,
            boxShadow: "1px 0 2px 0 #e7e2e2",
          }}
        >
          <Box sx={{ position: "relative" }}>
            <AutoCompleteDropdown
              getOptionLabel={(option) => option.name}
              label="Exam Level"
              name="examLevel_display"
              options={ExamLevels}
              value={examLevel}
              onChange={(selectedValue) => {
                if (!selectedValue) {
                  setExamLevel("");
                } else {
                  setExamLevel(selectedValue.value);
                }
              }}
            />
            {/* ✅ Hidden input for form submission */}
            <input type="hidden" name="examLevel" value={examLevel || ""} />
          </Box>
          <Box sx={{ position: "relative" }}>
            <AutoCompleteDropdown
              label="Exam Month"
              name="examMonth_display"
              options={ExamLevelDateMap[examLevel] || []}
              getOptionLabel={(option) => option.name}
              value={examMonth}
              onChange={(selectedValue) => {
                if (!selectedValue) {
                  setExamMonth("");
                } else {
                  setExamMonth(selectedValue.value);
                }
              }}
              disabled={!examLevel}
              inputProps={{ required: true }}
            />

            {/* 🔥 BACKEND-COMPATIBLE PAYLOAD */}
            <input
              type="hidden"
              name="selectedDate"
              value={formatMonthYearToDate(examMonth)}
              required
            />
          </Box>
        </Grid>

        {/* Group 2: Contact & Location */}
        <Grid
          item
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 3,
            padding: 1,
            boxShadow: "1px 0 2px 0 #e7e2e2",
          }}
        >
          <InputField
            label="Phone Number"
            name="mobileNumber"
            type="text"
            inputProps={{
              maxLength: 10,
            }}
          />
          <AutoCompleteDropdown
            getOptionLabel={(option) => option.shortName}
            label="Division"
            name="divisionId"
            options={getOptions(divisions, "divisionId")}
            value={divisionVal}
            inputProps={{ required: false }}
            onChange={(selectedValue) => {
              if (!selectedValue) {
                setDivisionVal("");
              } else {
                setDivisionVal(selectedValue.value);
                setMetaDataInRedux(
                  SET_SUB_DIVISIONS,
                  selectedValue.subDivisions
                );
              }
            }}
            useHiddenInput
          />
        </Grid>

        {/* Group 3: Exam Level */}
        <Grid
          item
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 3,
            padding: 1,
            boxShadow: "1px 0 2px 0 #e7e2e2",
          }}
        >
          <InputField label="Member ID" name="memberId" />
          <InputField label="Member Name" name="fullName" />
        </Grid>

        {/* Group 4: Empty */}
        <Grid
          item
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 3,
            padding: 1,
            boxShadow: "1px 0 2px 0 #e7e2e2",
          }}
        >
          {/* Empty group for future use */}
        </Grid>
      </Grid>
    </Box>
  );
}

export default ResultPersonalDetailSearch;
